export const getSourceColor = (source: string | undefined) => {
  switch (source) {
    case '지하수':
      return 'bg-yellow-100 text-yellow-800';
    case '계곡수':
      return 'bg-teal-100 text-teal-800';
    case '지하수+계곡수':
      return 'bg-indigo-100 text-indigo-800';
    case '양수장':
      return 'bg-red-100 text-red-800';
    case '기타':
      return 'bg-gray-100 text-gray-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
